import _typeof from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProjectTicketSelect, getProjectTicketInfo, getProjectTicketItem, getProjectTicketItemResponsiblePerson, searchUserList, allocationProjectTicket, modifyProjectTicket } from '../../api';
export default {
  name: 'ticketAssignDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '分配工单'
    },
    successMessage: {
      type: String,
      default: '分配成功'
    },
    // submit 接口场景：allocation 分配负责人 / modify 修改负责人
    mode: {
      type: String,
      default: 'allocation'
    }
  },
  data: function data() {
    return {
      ticketId: null,
      assignForm: {
        category_id: '',
        second_category_id: '',
        item_id: '',
        handler_id: [],
        remarks: ''
      },
      assignRules: {
        category_id: [{
          required: true,
          message: '请选择咨询事项',
          trigger: 'change'
        }],
        second_category_id: [{
          required: true,
          message: '请选择二级事项',
          trigger: 'change'
        }],
        item_id: [{
          required: true,
          message: '请选择具体事项',
          trigger: 'change'
        }],
        handler_id: [{
          required: true,
          message: '请选择工单负责人',
          trigger: 'change'
        }]
      },
      assignLoading: false,
      ticketCategoryTree: [],
      secondCategoryOptions: [],
      itemOptions: [],
      // 人员下拉远程搜索：按下拉字段隔离选项，已选项缓存记录 id→选项（换关键字后已选标签不退化）
      personOptions: {},
      personOptionCache: {},
      personLoading: false
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    open: function open(id) {
      var _this = this;
      this.ticketId = id;
      this.assignForm = {
        category_id: '',
        second_category_id: '',
        item_id: '',
        handler_id: [],
        remarks: ''
      };
      this.secondCategoryOptions = [];
      this.itemOptions = [];
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.assignForm && _this.$refs.assignForm.clearValidate();
      });
      this.loadDetail(id);
    },
    loadCategoryTree: function loadCategoryTree() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getProjectTicketSelect();
            case 1:
              res = _context.v;
              _this2.ticketCategoryTree = res.data && res.data.tree || [];
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    loadDetail: function loadDetail(id) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, detail, presetUsers, firstCat;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (_this3.ticketCategoryTree.length) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return _this3.loadCategoryTree();
            case 1:
              _context2.n = 2;
              return getProjectTicketInfo({
                id: id
              });
            case 2:
              res = _context2.v;
              detail = res.data || {};
              _this3.assignForm = {
                category_id: detail.category_id != null ? String(detail.category_id) : '',
                second_category_id: detail.second_category_id != null ? String(detail.second_category_id) : '',
                item_id: detail.item_id != null ? String(detail.item_id) : '',
                handler_id: (detail.handler || []).map(function (item) {
                  return item && item.handler_id;
                }).filter(function (id) {
                  return id !== undefined && id !== null && id !== '';
                }).map(String),
                remarks: ''
              };
              // 已选工单负责人回填选项：选项列表为空时下拉标签会退化成 ID
              presetUsers = (detail.handler || []).map(function (item) {
                return item || {};
              }).filter(function (item) {
                return item.handler_id !== undefined && item.handler_id !== null && item.handler_id !== '';
              }).map(function (item) {
                return {
                  id: String(item.handler_id),
                  name: item.handler_name || '',
                  nick_name: item.handler_name || ''
                };
              });
              if (presetUsers.length) {
                presetUsers.forEach(function (user) {
                  _this3.personOptionCache[user.id] = user;
                });
                _this3.$set(_this3.personOptions, 'handler', presetUsers);
              }
              if (_this3.assignForm.category_id) {
                firstCat = _this3.ticketCategoryTree.find(function (item) {
                  return String(item.id) === _this3.assignForm.category_id;
                });
                if (firstCat && Array.isArray(firstCat.children)) {
                  _this3.secondCategoryOptions = firstCat.children || [];
                }
              }
              if (!(_this3.assignForm.second_category_id && _this3.assignForm.second_category_id !== '0')) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return _this3.loadItemOptions(_this3.assignForm.second_category_id);
            case 3:
              if (!(!_this3.assignForm.handler_id.length && _this3.assignForm.item_id)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 4;
              return _this3.loadDefaultHandlers(_this3.assignForm.item_id);
            case 4:
              // 打开弹窗时预载工单负责人选项（空关键词返回默认列表）
              _this3.searchHandler('');
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 人员下拉通用远程搜索：结果按字段存进 personOptions，已选项从缓存回填
    searchPerson: function searchPerson(keyword, field, valueGetter) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var kw, res, list, selected, picked;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              kw = (keyword || '').trim();
              _this4.personLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return searchUserList({
                keyword: kw
              });
            case 2:
              res = _context3.v;
              list = res.data || [];
              list.forEach(function (item) {
                _this4.personOptionCache[String(item.id)] = item;
              });
              // 结果并入已选项：换关键字会销毁旧 option，已选标签需继续有数据可查
              selected = valueGetter();
              if (!Array.isArray(selected)) {
                selected = selected === undefined || selected === null || selected === '' ? [] : [selected];
              }
              picked = selected.filter(function (id) {
                return !list.some(function (item) {
                  return String(item.id) === String(id);
                });
              }).map(function (id) {
                return _this4.personOptionCache[String(id)];
              }).filter(Boolean);
              _this4.$set(_this4.personOptions, field, picked.concat(list));
            case 3:
              _context3.p = 3;
              _this4.personLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))();
    },
    // 工单负责人（分配/修改负责人）
    searchHandler: function searchHandler(keyword) {
      var _this5 = this;
      return this.searchPerson(keyword, 'handler', function () {
        return _this5.assignForm.handler_id;
      });
    },
    handleCategoryChange: function handleCategoryChange(val) {
      this.assignForm.second_category_id = '';
      this.assignForm.item_id = '';
      this.assignForm.handler_id = [];
      this.secondCategoryOptions = [];
      this.itemOptions = [];
      if (!val) return;
      var cat = this.ticketCategoryTree.find(function (item) {
        return String(item.id) === val;
      });
      if (cat && Array.isArray(cat.children)) {
        this.secondCategoryOptions = cat.children;
      }
    },
    handleSecondCategoryChange: function handleSecondCategoryChange(val) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this6.assignForm.item_id = '';
              _this6.assignForm.handler_id = [];
              _this6.itemOptions = [];
              if (!(!val || val === '0')) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return _this6.loadItemOptions(val);
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    loadDefaultHandlers: function loadDefaultHandlers(itemId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, data, ids, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!itemId || itemId === '0')) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return getProjectTicketItemResponsiblePerson({
                item_id: itemId
              });
            case 2:
              res = _context5.v;
              data = res.data || {};
              ids = [].concat(_toConsumableArray(Array.isArray(data.first_responder_id) ? data.first_responder_id : []), _toConsumableArray(Array.isArray(data.second_responder_id) ? data.second_responder_id : []));
              _this7.assignForm.handler_id = _toConsumableArray(new Set(ids.filter(function (id) {
                return id !== undefined && id !== null && id !== '';
              }).map(String)));
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t = _context5.v;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 3]]);
      }))();
    },
    handleItemChange: function handleItemChange(val) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this8.assignForm.handler_id = [];
              _context6.n = 1;
              return _this8.loadDefaultHandlers(val);
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    loadItemOptions: function loadItemOptions(secondCategoryId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res, data, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return getProjectTicketItem({
                category_id: secondCategoryId
              });
            case 1:
              res = _context7.v;
              data = res.data;
              if (Array.isArray(data)) {
                _this9.itemOptions = data;
              } else if (data && _typeof(data) === 'object') {
                _this9.itemOptions = Object.keys(data).map(function (key) {
                  return data[key];
                }).filter(function (item) {
                  return item && item.id && item.name;
                });
              } else {
                _this9.itemOptions = [];
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t2 = _context7.v;
              _this9.itemOptions = [];
            case 3:
              return _context7.a(2);
          }
        }, _callee7, null, [[0, 2]]);
      }))();
    },
    handleDialogClose: function handleDialogClose(done) {
      done();
    },
    submitAssign: function submitAssign() {
      var _this0 = this;
      this.$refs.assignForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(valid) {
          var requestFn, _t3;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.p = _context8.n) {
              case 0:
                if (valid) {
                  _context8.n = 1;
                  break;
                }
                return _context8.a(2);
              case 1:
                _this0.assignLoading = true;
                _context8.p = 2;
                requestFn = _this0.mode === 'modify' ? modifyProjectTicket : allocationProjectTicket;
                _context8.n = 3;
                return requestFn({
                  id: _this0.ticketId,
                  category_id: _this0.assignForm.category_id,
                  second_category_id: _this0.assignForm.second_category_id,
                  item_id: _this0.assignForm.item_id,
                  remarks: _this0.assignForm.remarks,
                  handler_id: _this0.assignForm.handler_id
                });
              case 3:
                _this0.$message.success(_this0.successMessage);
                _this0.dialogVisible = false;
                _this0.$emit('success');
                _context8.n = 5;
                break;
              case 4:
                _context8.p = 4;
                _t3 = _context8.v;
              case 5:
                _context8.p = 5;
                _this0.assignLoading = false;
                return _context8.f(5);
              case 6:
                return _context8.a(2);
            }
          }, _callee8, null, [[2, 4, 5, 6]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};